import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './FinanceUploadFile.css';

const FINANCE_ROOT = process.env.REACT_APP_FINANCE_START_PATH || '/finance';

function FinanceUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={FINANCE_ROOT}
      sessionPrefix="finance_file"
    />
  );
}

FinanceUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default FinanceUploadFile;
